module.exports = __webpack_public_path__ + "static/media/paper29.9c3b7b8b.jpg";